import { BaseModel, ProjetModel, DevisModel } from "~/model"
import { useDataCacheStore, useProjetStore } from "~/stores"
import { InterventionResource } from "~/api"

export class InterventionModel extends BaseModel<InterventionResource> {
    static primaryKey = "IDINTERVENTION"

    get projet(): ProjetModel {
        const projetStore = useProjetStore()
        return projetStore.itemById[this.IDPROJET]
    }

    get devis(): DevisModel {
        const projetStore = useProjetStore()
        return projetStore.itemById[this.IDDEVIS]
    }

    get solde_du_text() {
        if (!this.SOLDE_DEVIS) return "0€"
        return `${this.SOLDE_DEVIS} € (${this.SOLDE_DEVIS_POURCENTAGE * 100}%)`
    }

    get isReclamationSav(): boolean {
        const dataCacheStore = useDataCacheStore()
        const typeInterventionSav = dataCacheStore.typeInterventionsList

        const isSav = typeInterventionSav?.find(
            (type) =>
                type.IDTYPE_INTERVENTION === this.IDTYPE_INTERVENTION &&
                type.CODE === "SAV",
        )
        return (
            this.SEMAINE_DE_POSE === 100 && this.FINALISEE === false && !!isSav
        )
    }

    get formatDuree(): string {
        // convertir DUREE_PREVUE en int
        const duree_prevue = parseInt(this.DUREE_PREVUE as unknown as string)

        if (!this.DUREE_PREVUE || duree_prevue === 0) return "1h (défaut)"

        // Les valeurs DUREE_PREVUE sont stockées en millisecondes dans la base de données
        let minutes = duree_prevue

        // Si c'est supérieur à 10000, c'est des millisecondes (ex: 3600000 ms = 1h)
        if (duree_prevue > 10000) {
            minutes = Math.floor(duree_prevue / 1000 / 60)
        }
        // Si c'est entre 1440 et 10000, c'est peut-être des secondes
        else if (duree_prevue > 1440) {
            minutes = Math.floor(duree_prevue / 60)
        }

        if (minutes < 60) {
            return `${minutes} min`
        }

        const heures = Math.floor(minutes / 60)
        const minutesRestantes = minutes % 60

        if (minutesRestantes === 0) {
            return `${heures}h`
        }

        return `${heures}h${minutesRestantes.toString().padStart(2, "0")}`
    }
}

export interface InterventionModel extends InterventionResource {}
